import * as THREE from 'three';

const curvatorComponent = {
  schema: {
    curvatureX: { type: 'number', default: 0, min: -1, max: 1 },
    curvatureY: { type: 'number', default: 0, min: -1, max: 1 },
    segments: { type: 'int', default: 50 },
  },

  init: function () {
    let el = this.el;
    let data = this.data;

    // Get plane dimensions from original geometry
    let width = el.getAttribute('geometry').width || 1;
    let height = el.getAttribute('geometry').height || 1;

    // Create subdivided plane geometry for smooth curving
    let geometry = new THREE.PlaneGeometry(
      width,
      height,
      data.segments,
      data.segments
    );

    let positions = geometry.attributes.position;

    for (let i = 0; i < positions.count; i++) {
      let x = positions.getX(i);
      let y = positions.getY(i);
      let z = 0;

      let newX = x;
      let newY = y;
      let newZ = z;

      // X-axis cylindrical transformation (wrap horizontally)
      let curvatureXAbs = Math.abs(data.curvatureX);
      if (curvatureXAbs > 0) {
        let totalAngle = curvatureXAbs * 2 * Math.PI;
        let radius = width / totalAngle;
        let angle = (x / width) * totalAngle;

        // Convert to cylindrical coordinates (circle in XZ plane)
        newX = radius * Math.sin(angle);
        let signX = Math.sign(data.curvatureX);
        newZ = signX * radius * (1 - Math.cos(angle)); // Flip Z direction for negative curvature
      }

      // Y-axis cylindrical transformation (wrap vertically)
      let curvatureYAbs = Math.abs(data.curvatureY);
      if (curvatureYAbs > 0) {
        let totalAngle = curvatureYAbs * 2 * Math.PI;
        let radius = height / totalAngle;
        let angle = (y / height) * totalAngle;

        newY = radius * Math.sin(angle);
        let signY = Math.sign(data.curvatureY);
        newZ += signY * radius * (1 - Math.cos(angle)); // Accumulate Z with direction; flip for negative
      }

      positions.setX(i, newX);
      positions.setY(i, newY);
      positions.setZ(i, newZ);
    }

    positions.needsUpdate = true;
    geometry.computeVertexNormals();

    // Replace the mesh geometry
    el.getObject3D('mesh').geometry = geometry;
  },
};
export { curvatorComponent };
